{
  "Approve": "Approva",
  "DeleteReminder": "Elimina promemoria",
  "DismissAlert": "Ignora",
  "DismissReminder": "Ignora promemoria",
  "Earlier": "PRECEDENTI",
  "EditReminder": "Modifica promemoria",
  "High": "Alta",
  "MarkAllAsRead": "Segna tutto come letto",
  "Reject": "Rifiuta",
  "RemindMe15Min": "Ricordami tra 15 minuti",
  "RemindMe5Min": "Ricordami tra 5 minuti",
  "RemindMe60Min": "Ricordami tra 1 ora",
  "RemindMeTomorrow": "Ricordami domani",
  "Snooze": "Attiva promemoria",
  "markAsRead": "Segna come letto",
  "markAsUnread": "Segna come non letto",
  "noNotifications": "Riceverai informazioni importanti sui nostri prodotti, sulla collaborazione con gli altri utenti e altri aggiornamenti rilevanti",
  "noNotificationsTitle": "Le notifiche appariranno qui"
}
